module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_ussr.dcc5d765.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_ussr.png
// module id = 1249
// module chunks = 16